module.exports = __webpack_public_path__ + "img/logo.e2211f50.png";